import { render, staticRenderFns } from "./callForEntrepreneursEdition.vue?vue&type=template&id=8f3f40f2"
import script from "./callForEntrepreneursEdition.vue?vue&type=script&lang=js"
export * from "./callForEntrepreneursEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports